// layout 
export const Loading = 'Loading...';
export const BonusUi = 'Bonus Ui';
export const MegaMenu = 'Mega menu';
export const ErrorPage = 'Error Page';
export const Authentication = 'Authentication';
export const UsefulPages = 'Useful Pages';
export const ComingSoon = 'Coming Soon';
export const PageNotFound = 'Page Not Found';
export const ErrorPageContent = 'The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved.';
export const Error2Head = 'Oops! This Page is Not Found.';
export const Error3Head = 'Sorry, Something Goes Wrong';
export const Error4Head = 'Internal Server Error';
export const BACK_TO_HOME_PAGE = '';
export const CONST_USER_ID = 'userid';
export const CONST_DISPLAY_NAME= 'display_name';
export const DELAY_TIMER = 1000;
export const OTP_DELAY_TIMER = 120;

// Social
export const TwitterLink = 'https://twitter.com/minersdatacom';
export const LinkedInLink = 'https://www.linkedin.com/company/miners-data/';
export const YoutubeLink = 'https://www.youtube.com/@MinersData';
export const DISCORD_LINK = 'https://discord.gg/FagQvWY5j3';
export const TANDC_LINK = 'https://tandc.minersdata.com/';
export const PRIVACY_LINK = 'https://privacy.minersdata.com/';